import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesDataReport {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        if (webcontext.Client.PageName == "DataReport") {
            //报缺货
            if (webcontext.ConfigName == "TBAppOrderQuantityXML" && webcontext.OpType.toLowerCase() == "add") {
                webcontext.ConfigName = "TBShangBaoXiaoLiangXML";
                webcontext.RequestBody = this.formateData(webcontext.RequestBody);
                console.log(webcontext);
            }
        }
        return webcontext;
    }

    private formateData(data: string): string {
        let res = JSON.parse(data);
        let arr: Array<any> = new Array<any>();
        let resItem: Object;
        res.forEach((item, i) => {
            resItem = {
                'a_GroupingName': item.a_GroupingName,
                'a_title': item.a_title,
                'a_XiaoLiang': item.a_XiaoLiang,
                'a_ZiRanXiaoLiang': item.a_ZiRanXiaoLiang,
                'a_XiaoLiangHeJi': item.a_XiaoLiangHeJi,
            }
            arr.push(resItem);
        })
        return JSON.stringify(arr);
    }

    public ContextBeforeChangeValue(webcontext: any, ConfigName: string): any {
        if (ConfigName == "DataReport") {
            if (webcontext.a_ZiRanXiaoLiang > 0) {
                webcontext.a_XiaoLiangHeJi = webcontext.a_ZiRanXiaoLiang + (webcontext.a_XiaoLiang ? webcontext.a_XiaoLiang : webcontext.a_XiaoLiang = 0);
            }
        }
        return webcontext;
    }

}